import React from 'react';
import FormContents from 'components/atoms/Form/FormContents';
import WorkingHoursInputAddForm from './WorkingHoursInputAddForm';
import { useParams } from 'react-router-dom';
import FormHeader from 'components/templates/FormHeader';
import { css } from '@emotion/core';

const WorkingHoursAddForm: React.FC = () => {
  const {workingHoursId}  = useParams();
  return(
    <React.Fragment>
      <FormHeader title={`${workingHoursId ? "所定労働時間編集" : "所定労働時間作成"}`} />
      <FormContents customStyle={css({marginTop:'60px'})}>
	      <WorkingHoursInputAddForm workingHoursId={workingHoursId || ''} />
	    </FormContents>
    </React.Fragment>
  );
};

export default WorkingHoursAddForm;
